import { EQUITY_HOLDING_LIVE_NEWS, LIVE_NEWS, LIVE_NEWS_ERROR, LIVE_NEWS_HIDE_ERROR, LIVE_NEWS_START_LOADER, LIVE_NEWS_STOP_LOADER, LIVE_NEWS_STREAM, QOUTE_STREAM_NEWS, RESET_STREAM_COUNT, } from "../interface/iLiveNewsReducer";
import { updateNewsQouteStream } from "@domains/utils/liveNewsStream";
const initialState = {
    liveNewsData: {
        content: [],
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
    },
    equityHoldingliveNewsData: {
        content: [],
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
    },
    liveNewsLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    streamCount: 0,
};
const liveNewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIVE_NEWS: {
            return Object.assign(Object.assign({}, state), { liveNewsData: action.payload.data });
        }
        case EQUITY_HOLDING_LIVE_NEWS: {
            return Object.assign(Object.assign({}, state), { equityHoldingliveNewsData: action.payload.data });
        }
        case QOUTE_STREAM_NEWS:
            return Object.assign(Object.assign({}, state), { liveNewsData: Object.assign(Object.assign({}, state.liveNewsData), { content: updateNewsQouteStream(state.liveNewsData.content, action.payload.qouteStream) }) });
        case LIVE_NEWS_STREAM:
            return Object.assign(Object.assign({}, state), { liveNewsData: Object.assign(Object.assign({}, state.liveNewsData), { content: [action.payload.liveNewsData, ...state.liveNewsData.content] }), streamCount: state.streamCount + 1 });
        case RESET_STREAM_COUNT:
            return Object.assign(Object.assign({}, state), { streamCount: initialState.streamCount });
        case LIVE_NEWS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case LIVE_NEWS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case LIVE_NEWS_START_LOADER:
            return Object.assign(Object.assign({}, state), { liveNewsLoader: true });
        case LIVE_NEWS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { liveNewsLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default liveNewsReducer;
